import { Box, IconButton, Stack, Typography, useTheme } from "@mui/material";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";

export default function NotesList({ notes, handleOpenBoard }) {
    const theme = useTheme();
    const isDarkMode = theme.palette.mode === "dark";

    return (
        <Stack spacing={2}>
            {[...notes].reverse().map((note) => (
                <Box
                    key={note.id}
                    onClick={() => handleOpenBoard(note.id)}
                    sx={{
                        bgcolor: "background.paper",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        padding: "10px",
                        borderRadius: "12px",
                        cursor: "pointer",
                        transition: "0.3s ease",
                        "&:hover": {
                            bgcolor: isDarkMode
                                ? "rgba(255,255,255,0.1)"
                                : "rgba(0,0,0,0.1)",
                        },
                    }}
                >
                    <Typography color="text.primary">
                        {note.title.trim()
                            ? note.title
                            : note.note.split(" ").slice(0, 3).join(" ")}
                    </Typography>
                    <IconButton>
                        <KeyboardArrowRightIcon />
                    </IconButton>
                </Box>
            ))}
        </Stack>
    );
}
